export default "__VITE_ASSET__BBeSWxHl__"